import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';

export default class Modalsentroom extends Component {
    constructor(props) {
        super(props);
this.state = {
    modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   send_comment1:"",
   send_comment4:"",


   filecomment1:null,
   filecomment2:null,
}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChange4 = this.handleChange4.bind(this);
//this.getExpert = this.getExpert.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.props.selectatf();
}


 componentDidMount() {
    //  const { id_send } = this.props.id_send
     // console.log(id_send);
      //this.setState({ id_send:this.props.id_send})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }




  handleChange(event) {    this.setState({filecomment1: event.target.files[0]});  }
  handleChange3(event) {    this.setState({filecomment2: event.target.files[0]});  }
  handleChange2(event) {    this.setState({send_comment1: event.target.value});  }
  handleChange4(event) {    this.setState({send_comment4: event.target.value});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idsend", this.state.id_send);
      datafrm.append("send_comment1", this.state.send_comment1);
      datafrm.append("avatar", this.state.filecomment1);
      datafrm.append("send_comment4", this.state.send_comment4);
      datafrm.append("avatar2", this.state.filecomment2);

      
  Axios.post("https://conference.kpru.ac.th/PHPAPI/uploadcomment1show.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.data.status = 'success999') {
      message.success("อัพโหลไฟล์สำเร็จ")
     // window.location.href = '/adminfaculty'
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }
  })


//อัพเดทสถานะ
  Axios
  // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
    .post("https://conference.kpru.ac.th/PHPAPI/updatestapat4.php",datafrm)
    .then(res => {
      console.log("response: ", res)
 
      if (res.data.length !== 0) {
       // this.showitem = true;
        console.log(res)
        console.log(res.data.length)
     }else{
      // window.location.href = '/'
     }
     this.toggle()
   })
   this.toggle()
}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 


  }

  

    render() {
        
        return (
            <MDBContainer>
            <MDBBtn color="danger" onClick={this.toggle}>อัพโหลดข้อเสนอ</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>{this.props.namearticla}</MDBModalHeader>
              <MDBModalBody>
              <div>

              <p>ข้อเสนอแนะผู้ทรงคุณวุฒิ {this.state.idExpert}</p>   
              <MDBInput type="textarea" label="ข้อเสนอแนะผู้ทรงคุณวุฒิ" value={this.state.value} onChange={this.handleChange2} outline />

               <p>อัพโหลดไฟล์ข้อเสนอแนะของผู้ทรงคุณวุฒิ {this.state.idExpert}</p>
               <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                success="right"  name="file" value={this.state.value} onChange={this.handleChange}/>

            <p>ข้อเสนอแนะบรรณาธิการ {this.state.idExpert}</p>   
              <MDBInput type="textarea" label="ข้อเสนอแนะบรรณธิการ" value={this.state.value} onChange={this.handleChange4} outline />

               <p>อัพโหลดไฟล์ข้อเสนอแนะของบรรณาธิการ {this.state.idExpert2}</p>
               <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/>
{/* 
{this.state.send_comment1} */}


              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
